/**
 * @returns A simple title card.
 */
const TitleCard = () => {
  return (
    <div id="title">
      <h1>Sorting Algorithms</h1>
      <h4>
        <i>WARNING: Animation contains flashing lights</i>
      </h4>
      <h5>
        © 2021 John Marcus Mabanta ·{' '}
        <a
          href="https://github.com/jmmabanta/sort-algo"
          target="_blank"
          rel="noopener noreferrer"
        >
          Source Code
        </a>
      </h5>
    </div>
  );
};

export default TitleCard;
